import { createContext, useContext, useState, useCallback } from "react";
import { useAuth } from "./useAuth";
import { usePro } from "./usePro";

export const FREE_LIMIT = 10;
const KEY = "launchbs_idea_views";

const read = () => {
  try {
    return parseInt(localStorage.getItem(KEY) || "0", 10) || 0;
  } catch {
    return 0;
  }
};

const IdeaLimitContext = createContext(null);

export const IdeaLimitProvider = ({ children }) => {
  const { user, promptLogin } = useAuth();
  const { isPro, openUpgrade } = usePro();

  // Business ideas are Pro-only. Opening a full idea requires Pro; otherwise we
  // prompt account creation (signed-out) or an upgrade (signed-in free).
  const gateIdea = useCallback(() => {
    if (isPro) return true;
    if (!user) promptLogin("idea_limit");
    else openUpgrade("welcome");
    return false;
  }, [isPro, user, promptLogin, openUpgrade]);

  const triggerGate = useCallback(() => {
    if (!user) promptLogin("idea_limit");
    else openUpgrade("welcome");
  }, [user, promptLogin, openUpgrade]);

  return (
    <IdeaLimitContext.Provider value={{ isPro, gateIdea, triggerGate }}>
      {children}
    </IdeaLimitContext.Provider>
  );
};

export const useIdeaLimit = () => useContext(IdeaLimitContext);
